import React, { Component } from "react";
import SearchIcon from "../icons/SearchIcon";
import "../style/SearchBar.css";

export class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      lastSearchTerm: ""
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    this.setState({ searchTerm: e.target.value }, () => {
      if (this.state.searchTerm.length < 1) {
        this.props.removeSearchQuery(this.state.lastSearchTerm);
      }
      console.log(this.state);
    });
  }
  clean(str) {
    const strArr = str.split(" ");
    const noSpacesArr = strArr.filter(el => el.length > 0);
    return noSpacesArr.join(" ");
  }
  handleSubmit(e) {
    e.preventDefault();
    const cleanedSearchTerm = this.clean(this.state.searchTerm);

    this.props.removeSearchQuery(this.state.lastSearchTerm);
    if (cleanedSearchTerm.length < 1) {
      // no blank queries
      return;
    } else {
      this.setState({ lastSearchTerm: cleanedSearchTerm });
      this.props.addSearchQuery(cleanedSearchTerm);
    }
  }
  render() {
    const placeholder = "Search for a motet by title";
    const searchLabel = "Search for a title";
    return (
      <div className="search">
        <label
          className={
            this.state.searchTerm ? "search-helper-active" : "search-helper"
          }
        >
          {searchLabel}
        </label>
        <form onSubmit={this.handleSubmit}>
          <input
            className="search-input"
            placeholder={placeholder}
            type="text"
            onChange={this.handleChange}
            value={this.state.searchTerm}
          />
          <button className="search-btn" type="submit">
            <SearchIcon />
          </button>
        </form>
      </div>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar.js